import gql from 'graphql-tag'

export const GET_ORGANIZATION_EVENT_TEMPLATE = gql`
  query GetOrganizationEventTemplate($organizationSlug: String!, $eventTemplateId: ID!) {
    getOrganizationEventTemplate(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      title
      durationInMins
      break
      eventCategoryId
      cover
      description
      tagIds
      webLink
      genreId
      facebookLink
      youtubeLink
      instagramLink
      VATPercentage
      organization {
        id
        VATObligor
      }
      events {
        id
        interests {
          id
        }
      }
    }
  }
`

export const EVENT_TEMPLATE_HAS_SOLD_TICKETS = gql`
  query EventTemplateHasSoldTickets($organizationSlug: String!, $eventTemplateId: ID!) {
    eventTemplateHasSoldTickets(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    )
  }
`
export const CREATE_EVENT_TEMPLATE_AND_PERFORMANCE = gql`
  mutation CreateEventTemplateAndPerformance(
    $organizationSlug: String!
    $eventTemplateInput: EventTemplateInput!
    $performanceInput: [PerformanceInput!]!
  ) {
    createEventTemplateAndPerformance(
      organizationSlug: $organizationSlug
      eventTemplateInput: $eventTemplateInput
      performanceInput: $performanceInput
    )
  }
`

export const UPDATE_EVENT_TEMPLATE_AND_PERFORMANCE = gql`
  mutation UpdateEventTemplateAndPerformance(
    $organizationSlug: String!
    $eventTemplateInput: EventTemplateInput!
    $publishChanges: Boolean
  ) {
    updateEventTemplateAndPerformance(
      organizationSlug: $organizationSlug
      eventTemplateInput: $eventTemplateInput
      publishChanges: $publishChanges
    ) {
      id
    }
  }
`
export const GET_ORGANIZATION_EVENT_TEMPLATE_AND_LOGGED_USER = gql`
  query GetOrganizationEventTemplate($organizationSlug: String!, $eventTemplateId: ID!) {
    getOrganizationEventTemplate(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      title
      durationInMins
      break
      eventCategoryId
      cover
      description
      tagIds
      webLink
      genreId
      facebookLink
      youtubeLink
      instagramLink
      VATPercentage
      organization {
        id
        VATObligor
      }
      events {
        status
        from
        slug
        extraModules {
          ticketing
        }
        interests {
          id
        }
      }
    }
    me {
      id
      firstName
      lastName
      type
      flags
      isVerifiedByCoreEvent
    }
  }
`

export const UPDATE_EVENT_TEMPLATE_COVER = gql`
  mutation UpdateEventTemplateCover(
    $organizationSlug: String!
    $eventTemplateId: ID!
    $cover: String
  ) {
    updateEventTemplateCover(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
      cover: $cover
    )
  }
`

export const SEARCH_EVENT_TEMPLATES_SUPERADMIN = gql`
  query SearchEventTemplatesSuperadmin($q: String!, $limit: Int) {
    searchEventTemplatesSuperadmin(q: $q, limit: $limit) {
      id
      title
    }
  }
`

export const GET_EVENT_TEMPLATE_DYNAMIC_WEBSHOP_TICKET_DATA = gql`
  query GetEventTemplateDynamicWebshopTicketData(
    $organizationSlug: String!
    $eventTemplateId: ID!
  ) {
    getEventsByEventTemplateId(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      cover
      organizerMessage
      metadata
    }
  }
`

export const UPDATE_EVENT_TEMPLATE_DYNAMIC_WEBSHOP_TICKET_DATA = gql`
  mutation UpdateEventTemplateDynamicWebshopTicketData(
    $eventTemplateId: ID!
    $mainImage: String
    $organizerMessage: String
    $additionalVisual: String
  ) {
    updateEventTemplateDynamicWebshopTicketData(
      eventTemplateId: $eventTemplateId
      mainImage: $mainImage
      organizerMessage: $organizerMessage
      additionalVisual: $additionalVisual
    )
  }
`

export const GET_ORGANIZATION_EVENT_TEMPLATES = gql`
  query GetOrganizationEventTemplates($organizationSlug: String!) {
    getOrganizationEventTemplates(organizationSlug: $organizationSlug) {
      id
      title
      events {
        id
        title
        from
        to
        eventTemplateId
        location {
          id
          venue
        }
      }
    }
  }
`

export const GET_THEATER_WORKING_EVENT_TEMPLATES = gql`
  query GetTheaterWorkingEventTemplates($organizationSlug: String!) {
    getTheaterWorkingEventTemplates(organizationSlug: $organizationSlug) {
      id
      title
      cover
      events {
        id
        from
        to
        cover
        extraModules {
          ticketing
        }
        totalNumberOfTickets
        totalEarnings
        totalTicketsSold
        location {
          city
        }
      }
    }
  }
`
